import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const changeRole = ({
  id,
  roleId,
}: {
  id: number,
  roleId: string,
}) => {

  const queryParams = {
    user_id: id,
    role: roleId
  };

  return axiosPrivate.post(`/dashboard/v1/staff_management/change_role`, queryParams);
};